import { Skeleton } from 'gcs-common/design-system/ui/skeleton';

const TicketItemSkeleton = () => {
  return (
    <div className="flex items-center space-x-4 p-4">
      <Skeleton className="h-12 w-12 rounded-full bg-neutral-4" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-[250px] bg-neutral-4" />
        <Skeleton className="h-4 w-[200px] bg-neutral-4" />
      </div>
    </div>
  );
};

export default TicketItemSkeleton;
